import { Button, Card, Input, Popconfirm, Space } from "antd";
import { DeleteOutlined, PlusOutlined, SaveOutlined } from "@ant-design/icons";
import { DraftImage, MaterialBlock } from "./types";
import { DraftImagesForm } from "./DraftImagesForm";
import { MaterialImagesTable } from "./MaterialImagesTable";

type MaterialBlockCardProps = {
  block: MaterialBlock;
  isSaving: boolean;
  isRemoving: boolean;
  removingIds: number[];
  onAddDraft: (blockKey: string) => void;
  onRemoveBlock: (block: MaterialBlock) => void;
  onRemoveDraft: (blockKey: string, draftKey: string) => void;
  onRemoveMaterial: (id: number) => void;
  onSave: (block: MaterialBlock) => void;
  onUpdateCaption: (blockKey: string, caption: string) => void;
  onUpdateDraft: (
    blockKey: string,
    draftKey: string,
    patch: Partial<DraftImage>
  ) => void;
};

export const MaterialBlockCard = ({
  block,
  isSaving,
  isRemoving,
  removingIds,
  onAddDraft,
  onRemoveBlock,
  onRemoveDraft,
  onRemoveMaterial,
  onSave,
  onUpdateCaption,
  onUpdateDraft,
}: MaterialBlockCardProps) => {
  return (
    <Card
      title={
        block.isNew ? (
          <Input
            value={block.caption}
            placeholder="Заголовок блока"
            maxLength={255}
            onChange={(event) => onUpdateCaption(block.key, event.target.value)}
          />
        ) : (
          block.caption
        )
      }
      extra={
        <Space>
          <Button
            icon={<PlusOutlined />}
            onClick={() => onAddDraft(block.key)}
            disabled={isSaving || isRemoving}
          >
            Добавить картинку
          </Button>
          <Popconfirm
            title="Удалить блок?"
            description="Будут удалены все картинки в этом блоке."
            okText="Удалить"
            cancelText="Отмена"
            onConfirm={() => onRemoveBlock(block)}
          >
            <Button
              danger
              icon={<DeleteOutlined />}
              loading={isRemoving}
              disabled={isSaving}
            >
              Удалить блок
            </Button>
          </Popconfirm>
        </Space>
      }
    >
      <MaterialImagesTable
        materials={block.materials}
        removingIds={removingIds}
        hasDrafts={!!block.drafts.length}
        onRemove={onRemoveMaterial}
      />

      <DraftImagesForm
        blockKey={block.key}
        drafts={block.drafts}
        isSaving={isSaving}
        onChange={onUpdateDraft}
        onRemove={onRemoveDraft}
      />

      <Button
        type="primary"
        icon={<SaveOutlined />}
        loading={isSaving}
        disabled={isRemoving}
        onClick={() => onSave(block)}
        style={{ marginTop: block.drafts.length ? 16 : 0 }}
      >
        Сохранить картинки
      </Button>
    </Card>
  );
};
